import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "../../../shared/contexts/auth/useAuth.ts";
import { useQueries } from "../../../shared/hooks/useQueries.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBillingActions() {
  const { api } = useAuth();
  const queryClient = useQueryClient();
  const { getBalanceQueryOptions } = useQueries();
  const topUp = useMutation({
    mutationFn: api.billingAdmin.topUp,
    onSuccess: async (_data, { principalId }) => {
      const balanceQueryOptions = getBalanceQueryOptions({ principalId });

      await queryClient.invalidateQueries({
        queryKey: balanceQueryOptions.queryKey,
      });
    },
  });

  return { topUp };
}
